import React, { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";

import { toast } from "react-toastify";

import Sidebar from "../../components/SideBar";
import NavTabs from "../../components/NavTabs";
import Label from "../../components/Label";
import Btn from "../../components/Button";

import Details from "./Details";
import Invites from "./Invites";
import Map from "./Map";

import EventApi from "../../services/event";
import { Grid } from "@material-ui/core";
import Loading from "../../components/Loading";

const Event = (props) => {
    const history = useHistory();

    const [event, setEvent] = useState({});
    const [categoryValues, setCategoryValues] = useState({});
    const [categoryNames, setCategory] = useState({});
    const [gradeValues, setGradeValues] = useState({});
    const [gradeNames, setGrade] = useState({});
    const [rows, setRows] = useState([[]]);
    const defaultPerson = {
        id: 0,
        name: "",
        email: "",
        cpf: "",
        phone: "",
        rfid: "",
        certificate: 0,
        enable: true,
        vip: false,
        status_id: 1,
        position_id: 0,
        category_id: 0,
    };
    const [person, setPerson] = useState(defaultPerson);
    const [isLoading, setIsloading] = useState(false);

    function onChangePerson(event) {
        const { value, name } = event.target;
        setPerson({ ...person, [name]: value });
    }

    function onChangeRow(number, id, item, val) {
        setRows(
            rows.map((col) => {
                return col.map((pos) => {
                    if (pos) {
                        if (pos.number === number && pos.id === id) return { ...pos, [item]: val };
                    }
                    return pos;
                });
            })
        );
    }

    useEffect(() => {
        const fetchEventData = async () => {
            try {
                const eventId = props.computedMatch.params.id;

                const eventResponse = await EventApi.getEvent(eventId);
                if (!eventResponse.data) {
                    toast.error("Evento não encontrado");
                    history.push("/events");
                    return;
                }

                setIsloading(true);

                const eventData = eventResponse.data.data;
                setEvent(eventData);

                const [positionsResponse, categoryResponse, gradeResponse] = await Promise.all([
                    EventApi.getPositionByEvent(eventId),
                    EventApi.getCategory(),
                    EventApi.getGrade(),
                ]);

                if (categoryResponse.data) {
                    const categoryMap = categoryResponse.data.data.reduce((acc, item) => {
                        acc[item.id] = item;
                        return acc;
                    }, {});

                    setCategory(Object.values(categoryMap).map((item) => item.name));
                    setCategoryValues(categoryMap);
                }

                if (gradeResponse.data) {
                    const gradeMap = gradeResponse.data.data.reduce((acc, item) => {
                        acc[item.id] = item;
                        return acc;
                    }, {});

                    setGrade(Object.values(gradeMap).map((item) => item.name));
                    setGradeValues(gradeMap);
                }

                if (positionsResponse.data) {
                    const positionsMatrix = Array(eventData.lines)
                        .fill()
                        .map(() => Array(eventData.columns).fill(null));

                    positionsResponse.data.data.forEach((item) => {
                        positionsMatrix[parseInt(item.line, 10)][parseInt(item.column, 10)] = {
                            id: item.id,
                            number: item.value,
                            isSelected: item.people.some((invited) => invited.arrived),
                        };
                    });

                    setRows(positionsMatrix);
                }
            } catch (error) {
                console.error("Erro ao carregar dados do evento:", error);
                toast.error("Ocorreu um erro ao carregar os dados do evento");
            } finally {
                setIsloading(false);
            }
        };

        fetchEventData();
    }, [props.computedMatch.params.id, history]);

    const data = [
        {
            name: "Detalhes",
            content: <Details data={event} />,
        },
        {
            name: "Convidados",
            content: <Invites data={event} />,
        },
        {
            name: "Mapa",
            content: (
                <Map
                    data={event}
                    rows={rows}
                    person={person}
                    categoryValues={categoryValues}
                    categoryNames={categoryNames}
                    gradeValues={gradeValues}
                    gradeNames={gradeNames}
                    setPerson={setPerson}
                    onChangeRow={onChangeRow}
                    onChangePerson={onChangePerson}
                />
            ),
        },
    ];

    const page = (
        <>
            <Grid
                container
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                style={{ justifyContent: "space-between" }}
            >
                <Label size="min" color="dark" align="left" weight="500">
                    Eventos Cadastrados
                </Label>
                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "center",
                        alignContent: "center",
                        gap: "5px",
                    }}
                >
                    {/* <Link to={'/subscription/'+event.id}>
                        <Btn
                            size='nano'
                            color='dark'
                            format='solid'
                            width='100%'
                        >
                            Página Inscrição
                        </Btn>
                    </Link> */}
                    <Link to={"/credential/" + event.id}>
                        <Btn size="nano" color="dark" format="solid" width="100%">
                            Credenciais
                        </Btn>
                    </Link>
                    <Link to={"/control/" + event.id}>
                        <Btn size="nano" color="dark" format="solid" width="100%">
                            Controle Acesso
                        </Btn>
                    </Link>
                    {/* <Link to={"/totem/" + event.id}>
                        <Btn size="nano" color="dark" format="solid" width="100%">
                            Totem
                        </Btn>
                    </Link> */}
                    {/* <Link to={"/find/cimi"}>
                        <Btn size="nano" color="dark" format="solid" width="100%">
                            Busca Eduzz
                        </Btn>
                    </Link> */}
                </div>
            </Grid>
            <NavTabs itens={data} />
        </>
    );

    if (isLoading) return <Loading />;

    return <Sidebar current="Eventos" content={page} />;
};

export default Event;
